export default "__VITE_ASSET__w_1$WRyG__"